module.exports = __webpack_public_path__ + "img/54.74c746b1.jpg";